module.exports = __webpack_public_path__ + "static/media/Swirlix_gaussian2.a1d1c832.png";